import { useLocale } from '@va/localization';
import { Paragraph, fontWeights, paragraphSizes } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import { getFormattedDateAndTime } from '@va/util/helpers';

export const DateCell = ({ value, tooltipText }: { value: number; tooltipText?: string }) => {
  const { locale } = useLocale();

  return (
    <TooltipWrapper content={tooltipText} disabled={!tooltipText}>
      <Paragraph
        colorClassName='text-mine-shaft'
        weight={fontWeights.medium}
        size={paragraphSizes.tiny}
        className='flex flex-nowrap text-14px! w-full justify-center'
      >
        {getFormattedDateAndTime(value, locale)}
      </Paragraph>
    </TooltipWrapper>
  );
};
